<!-- <div class="iq-client-compute overview-block-ptb">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="iq-client iq-client-style-1 text-center iq-has-grascale">
                    <app-partners [Images]="Images"></app-partners>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="blue-bg iq-analytics-clients">
    <div class="container">
        <app-our-clients-icons></app-our-clients-icons>
    </div>
</section>